import { Routes } from '@angular/router';
import { adminGuard, userCamperGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () => import('./features/home/home').then((c) => c.Home),
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadChildren: () => import('./features/admin/admin.routes').then((c) => c.adminRoutes),
  },
  {
    path: 'c/:id',
    // canActivate: [userCamperGuard],
    loadChildren: () => import('./features/user-camper/user-camper.routes').then((c) => c.userCamperRoutes),
  },
  // {
  //   path: 'user-camp',
  //   loadChildren: () => import('./features/user-camper/user-camper.routes').then((c) => c.userCamperRoutes),
  // },
  {
    path: 'registration',
    loadComponent: () => import('./features/registration/registration.component').then((c) => c.RegistrationComponent),
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./core/auth/auth-callback.component').then((c) => c.AuthCallbackComponent),
  },
];
